import React, { useState, createContext, useContext, useEffect } from 'react';

export const MenuContext = createContext();

export const MenuContextProvider = (props) => {
        const [menuContent, setMenuContent] = useState(
                [
                        {
                                title: 'MY STUDENTS',
                                items: [
                                        { name: 'Registrations', route: '/registrations', icon: 'clipboard', new: false },
                                        { name: 'Submissions', route: '/submissions', icon: 'check', new: false },
                                        { name: 'Results', route: '/results', icon: 'trophy', new: false },
                                ],
                                route: '/students',
                        },
                        {
                                title: 'COMPETITION INFO',
                                items: [
                                        { name: 'Timeline', route: '/timeline', icon: 'timeline', new: false },
                                        { name: 'Documents', route: '/documents', icon: 'documents', new: false },
                                ],
                                route: '/competition',
                        },
                        {
                                title: 'MARKING',
                                items: [
                                        { name: 'Judge', route: '/judge', icon: 'judge', new: true },
                                        // { name: 'External Marking', route: '/external', icon: 'marking', new: true },
                                ],
                                route: '/marking',
                        },
                ]
        );

        return (
                <MenuContext.Provider value={menuContent}>
                        {props.children}
                </MenuContext.Provider>
        );
};

export const useMenuContext = () => useContext(MenuContext);
